import { mentionStrategy } from './mentionStrategy';
import { Mention } from './Mention';
export var mentions = {
  strategy: mentionStrategy,
  component: Mention
};